import { ProjectBookmarksResultAjax } from './project-bookmarks.backend-model';
import { ProjectBookmark } from './project-bookmarks.model';

export function transformProjectBookmarks(
  projectBookmark: ProjectBookmarksResultAjax,
): ProjectBookmark {
  return {
    type: projectBookmark.type,
    subscribed: projectBookmark.subscribed === 'true',
    projectId: projectBookmark.project_id,
    id: getProjectBookmarkId(projectBookmark),
  };
}

function getProjectBookmarkId(
  projectBookmark: ProjectBookmarksResultAjax,
): string {
  return `${projectBookmark.type}${projectBookmark.project_id}`;
}
